import React from "react";

import { withItemsIntellegence } from "../../../shared/containers/containerItemsIntellegence";

import IntelligenceInTimeRangeButtonWrapper from "./intelligenceInTimeRangeButtonWrapper";
import TimeRangeIntellegence from "./timeRangeIntellegence";
import IntelligenceTimeRangeList from "./intelligenceTimeRangeList";
import SnackbarWrapper from "./../../../shared/items/static/snackbarWrapper";
import Notification from "./../../../shared/items/static/notification";
import getDates from "./../../../shared/services/date.service";

import styles from "./carsIntellegence.module.scss";

const isInvalidTime = (startDate, startTime, endDate, endTime) => {
  if (startDate === null || startTime == null || endDate === null || endTime === null) {
    return true;
  }

  let startHour = startTime.getHours();
  let startMin = startTime.getMinutes();
  let endHour = endTime.getHours();
  let endMin = endTime.getMinutes();

  let rangeStartDate = new Date(startDate);
  rangeStartDate.setHours(startHour);
  rangeStartDate.setMinutes(startMin);

  let rangeEndDate = new Date(endDate);
  rangeEndDate.setHours(endHour);
  rangeEndDate.setMinutes(endMin);

  let startDateUtc = getDates.getNullTimeDateUtcNumber(startDate);
  let endDateUtc = getDates.getNullTimeDateUtcNumber(endDate);

  return startDateUtc === endDateUtc && rangeStartDate > rangeEndDate;
};

const IntellegenceInTimeRangeForm = (props) => {
  const { onHandleChangeStore, rangeStartDate, rangeStartTime, rangeEndDate, rangeEndTime } = props;

  const startDate = getDates.getNullTimeDateUtcNumber(rangeStartDate);
  const endDate = getDates.getNullTimeDateUtcNumber(rangeEndDate);
  const currentDate = getDates.getNullTimeDateUtcNumber(new Date());

  let isTimeInvalid = isInvalidTime(rangeStartDate, rangeStartTime, rangeEndDate, rangeEndTime);

  const isButtonDisabled =
    !rangeStartDate ||
    !rangeStartTime ||
    !rangeEndDate ||
    !rangeEndTime ||
    isNaN(rangeStartDate) ||
    isNaN(rangeStartTime) ||
    isNaN(rangeEndDate) ||
    isNaN(rangeEndTime) ||
    startDate > currentDate ||
    startDate > endDate ||
    isTimeInvalid;

  return (
    <React.Fragment>
      <div className={styles.container_itemsTimeIntellegence}>
        <TimeRangeIntellegence onHandleChangeStore={onHandleChangeStore} valueStore={props} />
        <div className={styles.container_itemsTimeButtom}>
          <IntelligenceInTimeRangeButtonWrapper disabled={isButtonDisabled} />
        </div>
      </div>
      <div className={styles.container_timeRangeList}>
        <IntelligenceTimeRangeList onHandleChangeStore={onHandleChangeStore} />
      </div>
      <SnackbarWrapper isOpen={isTimeInvalid}>
        <Notification type="error">
          <p>{`Конечное время (${getDates.getTimeFormat1(rangeEndTime)}) не должно быть раньше начального (${getDates.getTimeFormat1(
            rangeStartTime
          )})`}</p>
        </Notification>
      </SnackbarWrapper>
    </React.Fragment>
  );
};

export default withItemsIntellegence(React.memo(IntellegenceInTimeRangeForm));
